import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../configs/axios.config";
import {
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  IconButton,
  Stack,
  Select,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  VStack,
  useToast,
  Heading,
  Input,
  Badge,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { FiMoreVertical, FiEye, FiEdit, FiTrash } from "react-icons/fi";
import { ImFilter } from "react-icons/im";
import { TbSettings, TbArrowsSort } from "react-icons/tb";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { FiSearch } from "react-icons/fi";
import {
  getDriversEarning,
  getDriversPayout,
  getDriversBonus,
  getDriversDeduction,
  getDriversFailed,
} from "../../../actions/finance/driveraccount.action";
import { Loading } from "../../../components/Loading";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";

const DriverAccount = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [earningData, setEarningData] = useState([]);
  const [earningFetching, setEarningFetching] = useState(false);
  const [earningItemsPerPage, setEarningItemsPerPage] = useState(10);
  const [earningCurrentPage, setEarningCurrentPage] = useState(1);
  const [earningTotalPages, setEarningTotalPages] = useState(1);
  const [earningTotalItems, setEarningTotalItems] = useState(0);
  const [earningQuery, setEarningQuery] = useState("");
  const [earningSearchInput, setEarningSearchInput] = useState("");
  const [earningSortField, setEarningSortField] = useState("");
  const [earningSortOrder, setEarningSortOrder] = useState("asc");

  const [bonusData, setBonusData] = useState([]);
  const [bonusFetching, setBonusFetching] = useState(false);
  const [bonusItemsPerPage, setBonusItemsPerPage] = useState(10);
  const [bonusCurrentPage, setBonusCurrentPage] = useState(1);
  const [bonusTotalPages, setBonusTotalPages] = useState(1);
  const [bonusTotalItems, setBonusTotalItems] = useState(0);
  const [bonusQuery, setBonusQuery] = useState("");
  const [bonusSearchInput, setBonusSearchInput] = useState("");
  const [bonusSortField, setBonusSortField] = useState("");
  const [bonusSortOrder, setBonusSortOrder] = useState("asc");

  const [payoutData, setPayoutData] = useState([]);
  const [payoutFetching, setPayoutFetching] = useState(false);
  const [payoutItemsPerPage, setPayoutItemsPerPage] = useState(10);
  const [payoutCurrentPage, setPayoutCurrentPage] = useState(1);
  const [payoutTotalPages, setPayoutTotalPages] = useState(1);
  const [payoutTotalItems, setPayoutTotalItems] = useState(0);
  const [payoutQuery, setPayoutQuery] = useState("");
  const [payoutSearchInput, setPayoutSearchInput] = useState("");
  const [payoutSortField, setPayoutSortField] = useState("");
  const [payoutSortOrder, setPayoutSortOrder] = useState("asc");

  const [deductionData, setDeductionData] = useState([]);
  const [deductionFetching, setDeductionFetching] = useState(false);
  const [deductionItemsPerPage, setDeductionItemsPerPage] = useState(10);
  const [deductionCurrentPage, setDeductionCurrentPage] = useState(1);
  const [deductionTotalPages, setDeductionTotalPages] = useState(1);
  const [deductionTotalItems, setDeductionTotalItems] = useState(0);
  const [deductionQuery, setDeductionQuery] = useState("");
  const [deductionSearchInput, setDeductionSearchInput] = useState("");
  const [deductionSortField, setDeductionSortField] = useState("");
  const [deductionSortOrder, setDeductionSortOrder] = useState("asc");

  const [failedData, setFailedData] = useState([]);
  const [failedFetching, setFailedFetching] = useState(false);
  const [failedItemsPerPage, setFailedItemsPerPage] = useState(10);
  const [failedCurrentPage, setFailedCurrentPage] = useState(1);
  const [failedTotalPages, setFailedTotalPages] = useState(1);
  const [failedTotalItems, setFailedTotalItems] = useState(0);
  const [failedQuery, setFailedQuery] = useState("");
  const [failedSearchInput, setFailedSearchInput] = useState("");
  const [failedSortField, setFailedSortField] = useState("");
  const [failedSortOrder, setFailedSortOrder] = useState("asc");

  const [error, setError] = useState();
  const standardOptions = [10, 20, 50];
  const getPerPageOptions = (dataLength, itemsPerPage) => {
    if (dataLength === 0) return standardOptions;
    if (dataLength < standardOptions[0]) return [dataLength];
    const filtered = standardOptions.filter((num) => num <= dataLength);
    if (itemsPerPage > dataLength && !filtered.includes(itemsPerPage)) {
      filtered.push(itemsPerPage);
      filtered.sort((a, b) => a - b);
    }
    return filtered;
  };

  const statusColorMap = {
    Pending: "yellow",
    Complete: "green",
    Failed: "red",
    Processing: "blue",
  };

  const loadEarningData = async () => {
    setEarningFetching(true);
    try {
      const response = await getDriversEarning(
        earningCurrentPage,
        earningItemsPerPage,
        earningQuery,
      );

      if (response.success) {
        let processedData = response.data.map((value, index) => ({
          srNo: (earningCurrentPage - 1) * earningItemsPerPage + index + 1,
          driver: value?.driver,
          driverid: value?.driverid,
          date: new Date(value?.date).toLocaleDateString("en-GB"),
          tripId: value?.tripId,
          distance: value?.distance,
          fare: `₹${value?.fare?.toLocaleString()}`,
          base: `₹${value?.base?.toLocaleString()}`,
          da: `₹${value?.da?.toLocaleString()}`,
          total: `₹${value?.total?.toLocaleString()}`,
        }));

        if (earningSortField) {
          processedData.sort((a, b) => {
            let aVal = a[earningSortField] || "";
            let bVal = b[earningSortField] || "";

            if (typeof aVal === "string") {
              aVal = aVal.toLowerCase();
              bVal = bVal.toLowerCase();
            }

            if (earningSortOrder === "asc") {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        setEarningData(processedData);
        setEarningTotalPages(response.pagination?.pages || 1);
        setEarningTotalItems(response.pagination?.total || 0);
      }
    } catch (error) {
      setError(error.message);
      console.log(error);
      toast({
        title: "Failed to fetch earning data!",
        description: error.message,
        status: "error",
        duration: 9000,
      });
    }
    setEarningFetching(false);
  };

  const loadBonusData = async () => {
    setBonusFetching(true);
    try {
      const response = await getDriversBonus(
        bonusCurrentPage,
        bonusItemsPerPage,
        bonusQuery,
      );

      if (response.success) {
        let processedData = response.data.map((value, index) => ({
          srNo: (bonusCurrentPage - 1) * bonusItemsPerPage + index + 1,
          driver: value?.driver,
          date: new Date(value?.date).toLocaleDateString("en-GB"),
          amount: `₹${value?.amount?.toLocaleString()}`,
          reason: value?.reason,
        }));

        if (bonusSortField) {
          processedData.sort((a, b) => {
            let aVal = a[bonusSortField] || "";
            let bVal = b[bonusSortField] || "";

            if (typeof aVal === "string") {
              aVal = aVal.toLowerCase();
              bVal = bVal.toLowerCase();
            }

            if (bonusSortOrder === "asc") {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        setBonusData(processedData);
        setBonusTotalPages(response.pagination?.pages || 1);
        setBonusTotalItems(response.pagination?.total || 0);
      }
    } catch (error) {
      setError(error.message);
      console.log(error);
      toast({
        title: "Failed to fetch bonus data!",
        description: error.message,
        status: "error",
        duration: 9000,
      });
    }
    setBonusFetching(false);
  };

  const loadPayoutData = async () => {
    setPayoutFetching(true);
    try {
      const response = await getDriversPayout(
        payoutCurrentPage,
        payoutItemsPerPage,
        payoutQuery,
      );

      if (response.success) {
        let processedData = response.data.map((value, index) => ({
          srNo: (payoutCurrentPage - 1) * payoutItemsPerPage + index + 1,
          payoutId: value?.payoutId,
          driver: value?.driver,
          amount: `₹${value?.amount?.toLocaleString()}`,
          method: value?.method,
          schedule: value?.schedule,
          status: value?.status,
        }));

        if (payoutSortField) {
          processedData.sort((a, b) => {
            let aVal = a[payoutSortField] || "";
            let bVal = b[payoutSortField] || "";

            if (typeof aVal === "string") {
              aVal = aVal.toLowerCase();
              bVal = bVal.toLowerCase();
            }

            if (payoutSortOrder === "asc") {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        setPayoutData(processedData);
        setPayoutTotalPages(response.pagination?.pages || 1);
        setPayoutTotalItems(response.pagination?.total || 0);
      }
    } catch (error) {
      setError(error.message);
      console.log(error);
      toast({
        title: "Failed to fetch payout data!",
        description: error.message,
        status: "error",
        duration: 9000,
      });
    }
    setPayoutFetching(false);
  };

  const loadDeductionData = async () => {
    setDeductionFetching(true);
    try {
      const response = await getDriversDeduction(
        deductionCurrentPage,
        deductionItemsPerPage,
        deductionQuery,
      );

      if (response.success) {
        let processedData = response.data.map((value, index) => ({
          srNo: (deductionCurrentPage - 1) * deductionItemsPerPage + index + 1,
          driver: value?.driver,
          date: new Date(value?.date).toLocaleDateString("en-GB"),
          amount: `₹${value?.amount?.toLocaleString()}`,
          reason: value?.reason,
        }));

        if (deductionSortField) {
          processedData.sort((a, b) => {
            let aVal = a[deductionSortField] || "";
            let bVal = b[deductionSortField] || "";

            if (typeof aVal === "string") {
              aVal = aVal.toLowerCase();
              bVal = bVal.toLowerCase();
            }

            if (deductionSortOrder === "asc") {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        setDeductionData(processedData);
        setDeductionTotalPages(response.pagination?.pages || 1);
        setDeductionTotalItems(response.pagination?.total || 0);
      }
    } catch (error) {
      setError(error.message);
      console.log(error);
      toast({
        title: "Failed to fetch bonus data!",
        description: error.message,
        status: "error",
        duration: 9000,
      });
    }
    setBonusFetching(false);
  };

  const loadFailedData = async () => {
    setFailedFetching(true);
    try {
      const response = await getDriversFailed(
        failedCurrentPage,
        failedItemsPerPage,
        failedQuery,
      );

      if (response.success) {
        let processedData = response.data.map((value, index) => ({
          srNo: (failedCurrentPage - 1) * failedItemsPerPage + index + 1,
          payoutId: value?.payoutId,
          date: value?.date,
          driver: value?.driver,
          amount: `₹${value?.amount?.toLocaleString()}`,
          method: value?.method,
          schedule: value?.schedule,
          reason: value?.reason,
          status: value?.status,
        }));

        if (failedSortField) {
          processedData.sort((a, b) => {
            let aVal = a[failedSortField] || "";
            let bVal = b[failedSortField] || "";

            if (typeof aVal === "string") {
              aVal = aVal.toLowerCase();
              bVal = bVal.toLowerCase();
            }

            if (failedSortOrder === "asc") {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        setFailedData(processedData);
        setFailedTotalPages(response.pagination?.pages || 1);
        setFailedTotalItems(response.pagination?.total || 0);
      }
    } catch (error) {
      setError(error.message);
      console.log(error);
      toast({
        title: "Failed to fetch failed data!",
        description: error.message,
        status: "error",
        duration: 9000,
      });
    }
    setFailedFetching(false);
  };

  // Handle Earning Search

  const applyEarningSort = (field) => {
    if (earningSortField === field) {
      setEarningSortOrder(earningSortOrder === "asc" ? "desc" : "asc");
    } else {
      setEarningSortField(field);
      setEarningSortOrder("asc");
    }
    setEarningCurrentPage(1);
  };

  const fetchDriverEarnings = async () => {
    try {
      setEarningFetching(true);

      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/api/accounts/driver/earnings`,
        {
          params: {
            page: earningCurrentPage,
            limit: earningItemsPerPage,
            search: earningSearchInput || undefined,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
          },
        },
      );

      const { data, totalItems, totalPages } = response.data;

      setEarningData(
        data.map((item, index) => ({
          srNo: (earningCurrentPage - 1) * earningItemsPerPage + index + 1,
          driver: item.driverName,
          date: item.tripDate,
          tripId: item.tripId,
          distance: `${item.distance} km`,
          fare: `₹${item.fare}`,
          base: `₹${item.baseFare}`,
          da: `₹${item.da}`,
          total: `₹${item.totalAmount}`,
        })),
      );

      setEarningTotalItems(totalItems);
      setEarningTotalPages(totalPages);
    } catch (error) {
      console.error("Earnings fetch error:", error);
    } finally {
      setEarningFetching(false);
    }
  };

  useEffect(() => {
    fetchDriverEarnings();
  }, [earningCurrentPage, earningItemsPerPage]);

  const handleEarningSearch = () => {
    setEarningCurrentPage(1);
    fetchDriverEarnings();
  };

  const handleEarningKeyPress = (e) => {
    if (e.key === "Enter") handleEarningSearch();
  };

  const handleBonusSearch = () => {
    setBonusQuery(bonusSearchInput);
    setBonusCurrentPage(1);
  };
  const handleDeductionSearch = () => {
    setDeductionQuery(deductionSearchInput);
    setDeductionCurrentPage(1);
  };
  const handleBonusKeyPress = (e) => {
    if (e.key === "Enter") {
      handleBonusSearch();
    }
  };
  const handleDeductionKeyPress = (e) => {
    if (e.key === "Enter") {
      handleDeductionSearch();
    }
  };

  const applyBonusSort = (field) => {
    if (bonusSortField === field) {
      setBonusSortOrder(bonusSortOrder === "asc" ? "desc" : "asc");
    } else {
      setBonusSortField(field);
      setBonusSortOrder("asc");
    }
    setBonusCurrentPage(1);
  };
  const applyDeductionSort = (field) => {
    if (deductionSortField === field) {
      setDeductionSortOrder(deductionSortOrder === "asc" ? "desc" : "asc");
    } else {
      setDeductionSortField(field);
      setDeductionSortOrder("asc");
    }
    setDeductionCurrentPage(1);
  };

  const handlePayoutSearch = () => {
    setPayoutQuery(payoutSearchInput);
    setPayoutCurrentPage(1);
  };

  const handlePayoutKeyPress = (e) => {
    if (e.key === "Enter") {
      handlePayoutSearch();
    }
  };

  const applyPayoutSort = (field) => {
    if (payoutSortField === field) {
      setPayoutSortOrder(payoutSortOrder === "asc" ? "desc" : "asc");
    } else {
      setPayoutSortField(field);
      setPayoutSortOrder("asc");
    }
    setPayoutCurrentPage(1);
  };

  const handleFailedSearch = () => {
    setFailedQuery(failedSearchInput);
    setFailedCurrentPage(1);
  };

  const handleFailedKeyPress = (e) => {
    if (e.key === "Enter") {
      handleFailedSearch();
    }
  };

  const applyFailedSort = (field) => {
    if (failedSortField === field) {
      setFailedSortOrder(failedSortOrder === "asc" ? "desc" : "asc");
    } else {
      setFailedSortField(field);
      setFailedSortOrder("asc");
    }
    setFailedCurrentPage(1);
  };

  useEffect(() => {
    if (activeTab === 0) {
      loadEarningData();
    }
  }, [
    earningCurrentPage,
    earningItemsPerPage,
    earningQuery,
    earningSortField,
    earningSortOrder,
    activeTab,
  ]);

  useEffect(() => {
    if (activeTab === 1) {
      loadBonusData();
    }
  }, [
    bonusCurrentPage,
    bonusItemsPerPage,
    bonusQuery,
    bonusSortField,
    bonusSortOrder,
    activeTab,
  ]);

  useEffect(() => {
    if (activeTab === 2) {
      console.log("🟦 activeTab:", activeTab);
      loadDeductionData();
    }
  }, [
    deductionCurrentPage,
    deductionItemsPerPage,
    deductionQuery,
    deductionSortField,
    deductionSortOrder,
    activeTab,
  ]);

  useEffect(() => {
    if (activeTab === 3) {
      loadPayoutData();
    }
  }, [
    payoutCurrentPage,
    payoutItemsPerPage,
    payoutQuery,
    payoutSortField,
    payoutSortOrder,
    activeTab,
  ]);

  useEffect(() => {
    if (activeTab === 4) {
      loadFailedData();
    }
  }, [
    failedCurrentPage,
    failedItemsPerPage,
    failedQuery,
    failedSortField,
    failedSortOrder,
    activeTab,
  ]);

  if (
    (earningFetching && earningData.length === 0 && activeTab === 0) ||
    (bonusFetching && bonusData.length === 0 && activeTab === 1) ||
    (deductionFetching && deductionData.length === 0 && activeTab === 2) ||
    (payoutFetching && payoutData.length === 0 && activeTab === 3) ||
    (failedFetching && failedData.length === 0 && activeTab === 4)
  ) {
    return <Loading />;
  }

  const renderPagination = (
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    dataLength,
    setCurrentPage,
    setItemsPerPage,
  ) => {
    const perPageOptions = getPerPageOptions(dataLength, itemsPerPage);

    return (
      <Flex justifyContent="space-between" alignItems="center" mt={4} gap={2}>
        <Flex align="center" gap={4} wrap="wrap" justify="center" mt={4}>
          <Text fontSize="sm" color="#8B909A">
            Showing:
          </Text>
          <Select
            size="sm"
            width="fit-content"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            {perPageOptions.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </Select>
          <Text fontSize="sm" color="#8B909A">
            of {totalItems}
          </Text>
        </Flex>

        <Flex alignItems="center" mt={4} gap={2}>
          <Button
            size="sm"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            isDisabled={currentPage === 1}
          >
            <GoChevronLeft />
          </Button>
          {(() => {
            let startPage = 1;
            let endPage = totalPages;

            if (totalPages > 5) {
              if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
              } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 4;
                endPage = totalPages;
              } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
              }
            }

            const pagesToShow = [];
            for (let i = startPage; i <= endPage; i++) {
              pagesToShow.push(
                <Button
                  key={i}
                  size="sm"
                  variant={i === currentPage ? "solid" : ""}
                  colorScheme={i === currentPage ? "blue" : ""}
                  bgColor={i === currentPage ? "#0F60FF" : "#F1F2F6"}
                  onClick={() => setCurrentPage(i)}
                >
                  <Text color={i === currentPage ? "#FFFFFF" : "#8B909A"}>
                    {i}
                  </Text>
                </Button>,
              );
            }
            return pagesToShow;
          })()}
          <Button
            size="sm"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            isDisabled={currentPage === totalPages}
          >
            <GoChevronRight />
          </Button>
        </Flex>
      </Flex>
    );
  };

  const renderSearchAndFilterBar = (
    searchInput,
    setSearchInput,
    handleSearch,
    handleKeyPress,
    sortOptions = [],
    applySortFn,
    sortField,
    sortOrder,
    title,
  ) => (
    <>
      <Flex
        justifyContent="space-between"
        flexDirection={{ base: "column", md: "row" }}
        mt={4}
        mb={4}
      >
        <Heading fontSize="xl" py={2} color="#333B69">
          {title}
        </Heading>
        <Flex w="100%" maxW="600px" gap={3} justifyContent="flex-end">
          {/* <Flex
            gap={0}
            alignItems="center"
            w="100%"
            maxW="300px"
            bg="white"
            px={3}
            h="40px"
            borderRadius="13"
            border="1px"
            borderColor="gray.200"
          > */}
          {/* <FiSearch color="#718EBF" fontSize="1rem" />
            <Input
              placeholder="Search for something"
              border="none"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyPress={handleKeyPress}
              _focus={{ outline: "none", boxShadow: "none" }}
              fontSize="sm"
              h="full"
              _placeholder={{ color: "#718EBF" }}
            />
            <Button size="sm" variant="ghost" onClick={handleSearch}>
              Search
            </Button> */}
          {/* </Flex> */}

          <Popover>
            <PopoverTrigger>
              <Flex
                gap={2}
                alignItems="center"
                justifyContent="center"
                w="100%"
                maxW="91px"
                bg="white"
                px={3}
                h="40px"
                borderRadius="13"
                cursor="pointer"
                border="1px"
                borderColor="gray.200"
              >
                <ImFilter color="#718EBF" fontSize="0.9rem" />
                <Text fontSize="sm" color="#718EBF">
                  Filter
                </Text>
              </Flex>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverBody>
                <Text fontSize="sm">Filter options coming soon...</Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          <Popover placement="bottom-end">
            <PopoverTrigger>
              <Flex
                gap={2}
                alignItems="center"
                justifyContent="center"
                px={3}
                h="40px"
                bg="white"
                border="1px"
                borderColor="gray.200"
                borderRadius="13px"
                cursor="pointer"
                _hover={{ bg: "gray.50" }}
              >
                <TbSettings color="#718EBF" fontSize="1.2rem" />
                <Text fontSize="sm" color="#718EBF">
                  Action
                </Text>
              </Flex>
            </PopoverTrigger>

            <PopoverContent w="160px">
              <PopoverArrow />
              <PopoverBody p={2}>
                <VStack align="stretch" spacing={1}>
                  <Button
                    size="sm"
                    variant="ghost"
                    justifyContent="flex-start"
                    leftIcon={<FiEye />}
                    onClick={() => console.log("View clicked")}
                  >
                    View
                  </Button>

                  <Button
                    size="sm"
                    variant="ghost"
                    justifyContent="flex-start"
                    leftIcon={<FiEdit />}
                    onClick={() => console.log("Edit clicked")}
                  >
                    Edit
                  </Button>

                  <Button
                    size="sm"
                    variant="ghost"
                    justifyContent="flex-start"
                    leftIcon={<FiTrash />}
                    colorScheme="red"
                    onClick={() => console.log("Delete clicked")}
                  >
                    Delete
                  </Button>
                </VStack>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          {/* <Flex
            alignItems="center"
            justifyContent="center"
            w="100%"
            maxW="40px"
            bg="white"
            h="40px"
            borderRadius="full"
            cursor="pointer"
            border="1px"
            borderColor="gray.200"
          >
            <TbSettings color="#718EBF" fontSize="1.3rem" />
          </Flex> */}
        </Flex>
      </Flex>
    </>
  );

  return (
    <Stack w="100%" spacing={6} p={6} minH="100vh">
      {/* Breadcrumbs */}
      <BreadCrumbMaker
        items={[
          { title: "Finance", link: "#" },
          { title: "Driver Payout", link: "/finance/driver", on: true },
        ]}
      />

      <Box borderRadius="3xl" p={6} mt={6}>
        <Tabs colorScheme="blue" index={activeTab} onChange={setActiveTab}>
          <TabList
            w="65%"
            h="55px"
            bg="#ECF0FF"
            borderRadius="4px"
            p="8px 10px"
            display="flex"
            gap="10px"
            alignItems="center"
          >
            {["Earning", "Bonus", "Deductions", "Payouts", "Failed"].map(
              (label) => (
                <Tab
                  key={label}
                  w="155px"
                  h="39px"
                  borderRadius="4px"
                  fontWeight="600"
                  fontSize="14px"
                  fontFamily="inter, sans-serif"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  cursor="pointer"
                  transition="all 0.2s"
                  _selected={{
                    bg: "#FFFFFF",
                    color: "#333B69",
                  }}
                  _notSelected={{
                    bg: "transparent",
                    color: "#333B69",
                  }}
                  _hover={{
                    bg: "#FFFFFF",
                  }}
                >
                  {label}
                </Tab>
              ),
            )}
          </TabList>

          <TabPanels>
            {/* Earning Tab */}
            <TabPanel px={0}>
              <Flex justify="space-between" align="center">
                <Text
                  fontFamily="Inter, sans-serif"
                  fontWeight="600"
                  fontSize="22px"
                  mb={4}
                  color="#333B69"
                >
                  Trip-Wise Earning
                </Text>

                {renderSearchAndFilterBar(
                  earningSearchInput,
                  setEarningSearchInput,
                  handleEarningSearch,
                  handleEarningKeyPress,
                  [
                    { field: "driver", label: "Driver" },
                    { field: "date", label: "Date" },
                    { field: "tripId", label: "Trip ID" },
                  ],
                  applyEarningSort,
                )}
              </Flex>

              <Box p={7} bg="white" overflowX="auto" borderRadius="3xl">
                {earningFetching && (
                  <Flex justify="center" py={4}>
                    <Text color="#718EBF">Loading...</Text>
                  </Flex>
                )}

                <Table size="sm" bg="white" fontSize="small">
                  <Thead>
                    {/* HEADER ROW */}
                    <Tr>
                      <Th color="#718EBF">SR. NO</Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          DRIVER <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          DATE <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          TRIP ID <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          DISTANCE <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          FARE <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          BASE <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          DA <TbArrowsSort />
                        </Flex>
                      </Th>
                      <Th color="#718EBF">
                        <Flex align="center" gap={1}>
                          TOTAL <TbArrowsSort />
                        </Flex>
                      </Th>
                    </Tr>

                    {/* SEARCH ROW */}
                    <Tr bg="#E0EAFF">
                      <Th /> {/* EMPTY for SR. NO */}
                      {Array(8)
                        .fill("")
                        .map((_, i) => (
                          <Th key={i} p={2} bg="#E0EAFF">
                            <Flex align="center" gap={2}>
                              <FiSearch
                                bg="white"
                                color="#718EBF"
                                fontSize="1rem"
                              />
                              <Input
                                size="xs"
                                placeholder="Search"
                                bg="white"
                                borderRadius="4px"
                              />
                            </Flex>
                          </Th>
                        ))}
                    </Tr>
                  </Thead>

                  <Tbody>
                    {earningData?.length > 0 ? (
                      earningData.map((row, index) => (
                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                          <Td>{row.srNo}</Td>
                          <Td>{row.driverid}</Td>
                          <Td
                            cursor="pointer"
                            color="blue.500"
                            onClick={() =>
                              navigate("/finance/driverdetails", {
                                state: { driver: row.driver },
                              })
                            }
                          >
                            {row.driver}
                          </Td>
                          <Td>{row.date}</Td>
                          <Td>{row.tripId}</Td>
                          <Td>{row.distance}</Td>
                          <Td>{row.fare}</Td>
                          <Td>{row.base}</Td>
                          <Td>{row.da}</Td>
                          <Td fontWeight="600">{row.total}</Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={9} textAlign="center" py={8}>
                          <Text color="#718EBF">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>

                {renderPagination(
                  earningCurrentPage,
                  earningTotalPages,
                  earningTotalItems,
                  earningItemsPerPage,
                  earningData.length,
                  setEarningCurrentPage,
                  setEarningItemsPerPage,
                )}
              </Box>
            </TabPanel>

            {/* Bonus Tab */}
            <TabPanel px={0} fontFamily="inter, sans-serif">
              <Flex justify="space-between" align="center">
                <Text
                  fontFamily="Inter, sans-serif"
                  fontWeight="600"
                  fontSize="22px"
                  mb={4}
                  color="#333B69"
                >
                  Bonuses & Incentives
                </Text>

                {renderSearchAndFilterBar(
                  bonusSearchInput,
                  setBonusSearchInput,
                  handleBonusSearch,
                  handleBonusKeyPress,
                  [
                    { field: "driver", label: "Driver" },
                    { field: "date", label: "Date" },
                    { field: "reason", label: "Reason" },
                  ],
                  applyBonusSort,
                  bonusSortField,
                  bonusSortOrder,
                )}
              </Flex>
              <Box p={7} bg="white" overflowX="auto" borderRadius="3xl">
                {bonusFetching && (
                  <Flex justify="center" py={4}>
                    <Text color="#718EBF">Loading...</Text>
                  </Flex>
                )}

                <Table
                  size="sm"
                  bg="white"
                  fontSize="small"
                  tableLayout="fixed"
                >
                  <Thead>
                    {/* HEADER ROW */}
                    <Tr>
                      <Th color="#718EBF" textAlign="left" w="80px">
                        SR. NO
                      </Th>

                      {["DRIVER", "DATE", "AMOUNT", "REASON"].map((label) => (
                        <Th
                          key={label}
                          color="#718EBF"
                          textAlign="left"
                          whiteSpace="nowrap"
                          w="120px"
                        >
                          <Flex align="center" gap={1}>
                            {label}
                            <TbArrowsSort color="#718EBF" fontSize="1rem" />
                          </Flex>
                        </Th>
                      ))}
                    </Tr>

                    {/* SEARCH ROW */}
                    <Tr bg="#E0EAFF">
                      <Th /> {/* Empty for SR. NO */}
                      {Array(4)
                        .fill("")
                        .map((_, i) => (
                          <Th key={i} p={2} bg="#E0EAFF" textAlign="left">
                            <InputGroup size="xs">
                              <InputLeftElement pointerEvents="none" h="100%">
                                <FiSearch color="#718EBF" fontSize="0.9rem" />
                              </InputLeftElement>

                              <Input
                                placeholder="Search"
                                bg="white"
                                borderRadius="4px"
                                pl="30px"
                                _focus={{ boxShadow: "none" }}
                              />
                            </InputGroup>
                          </Th>
                        ))}
                    </Tr>
                  </Thead>

                  <Tbody>
                    {bonusData?.length > 0 ? (
                      bonusData.map((row, index) => (
                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                          <Td>{row.srNo}</Td>
                          <Td>{row.driver}</Td>
                          <Td>{row.date}</Td>
                          <Td fontWeight="600">{row.amount}</Td>
                          <Td>{row.reason}</Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={5} textAlign="center" py={8}>
                          <Text color="#718EBF">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>

                {renderPagination(
                  bonusCurrentPage,
                  bonusTotalPages,
                  bonusTotalItems,
                  bonusItemsPerPage,
                  bonusData.length,
                  setBonusCurrentPage,
                  setBonusItemsPerPage,
                )}
              </Box>
            </TabPanel>

            {/* Deductions Tab */}

            <TabPanel px={0}>
              <Flex justify="space-between" align="center">
                <Text
                  fontFamily="Inter, sans-serif"
                  fontWeight="600"
                  fontSize="22px"
                  mb={4}
                  color="#333B69"
                >
                  Deductions
                </Text>
                {renderSearchAndFilterBar(
                  setDeductionSearchInput,
                  handleDeductionSearch,
                  handleDeductionKeyPress,
                  [
                    { field: "driver", label: "Driver" },
                    { field: "date", label: "Date" },
                    { field: "reason", label: "Reason" },
                  ],
                  applyDeductionSort,
                )}
              </Flex>

              <Box p={7} bg="white" overflowX="auto" borderRadius="3xl">
                {deductionFetching && (
                  <Flex justify="center" py={4}>
                    <Text color="#718EBF">Loading...</Text>
                  </Flex>
                )}

                <Table size="sm" bg="white" fontSize="small">
                  <Thead>
                    {/* HEADER ROW */}
                    <Tr>
                      <Th color="#718EBF">SR. NO</Th>

                      {["DRIVER", "DATE", "AMOUNT", "REASON"].map((label) => (
                        <Th key={label} color="#718EBF">
                          <Flex align="center" gap={1}>
                            {label}
                            <TbArrowsSort color="#718EBF" fontSize="1rem" />
                          </Flex>
                        </Th>
                      ))}
                    </Tr>

                    {/* SEARCH ROW */}
                    <Tr bg="#E0EAFF">
                      <Th></Th> {/* Empty for SR. NO */}
                      {Array(4)
                        .fill("")
                        .map((_, i) => (
                          <Th key={i} p={2} bg="#E0EAFF">
                            <InputGroup size="xs">
                              <InputLeftElement pointerEvents="none" h="100%">
                                <FiSearch color="#718EBF" fontSize="0.9rem" />
                              </InputLeftElement>

                              <Input
                                placeholder="Search"
                                bg="white"
                                borderRadius="4px"
                                pl="30px"
                                _focus={{ boxShadow: "none" }}
                              />
                            </InputGroup>
                          </Th>
                        ))}
                    </Tr>
                  </Thead>

                  <Tbody>
                    {deductionData?.length > 0 ? (
                      deductionData.map((row, index) => (
                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                          <Td>{row.srNo}</Td>
                          <Td>{row.driver}</Td>
                          <Td>{row.date}</Td>
                          <Td fontWeight="600">{row.amount}</Td>
                          <Td>{row.reason}</Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={5} textAlign="center" py={8}>
                          <Text color="#718EBF">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>

                {renderPagination(
                  deductionCurrentPage,
                  deductionTotalPages,
                  deductionTotalItems,
                  deductionItemsPerPage,
                  deductionData?.length || 0,
                  setDeductionCurrentPage,
                  setDeductionItemsPerPage,
                )}
              </Box>
            </TabPanel>

            {/* Payouts Tab */}
            <TabPanel px={0}>
              <Flex justify="space-between" align="center">
                <Text
                  fontFamily="Inter, sans-serif"
                  fontWeight="600"
                  fontSize="22px"
                  mb={4}
                  color="#333B69"
                >
                  Payouts
                </Text>

                {renderSearchAndFilterBar(
                  setPayoutSearchInput,
                  handlePayoutSearch,
                  handlePayoutKeyPress,
                  [
                    { field: "driver", label: "Driver" },
                    { field: "status", label: "Status" },
                    { field: "method", label: "Method" },
                  ],
                  applyPayoutSort,
                  payoutSortField,
                  payoutSortOrder,
                )}
              </Flex>

              <Box p={7} bg="white" overflowX="auto" borderRadius="3xl">
                {payoutFetching && (
                  <Flex justify="center" py={4}>
                    <Text color="#718EBF">Loading...</Text>
                  </Flex>
                )}

                <Table size="sm" bg="white" fontSize="small">
                  <Thead>
                    {/* HEADER ROW */}
                    <Tr>
                      <Th color="#718EBF">SR. NO</Th>

                      {[
                        "DRIVER ",
                        "AMOUNT ",
                        "METHOD",
                        "SCHEDULE",
                        "STATUS",
                      ].map((label) => (
                        <Th key={label} color="#718EBF">
                          <Flex align="center" gap={1}>
                            {label}
                            <TbArrowsSort color="#718EBF" fontSize="1rem" />
                          </Flex>
                        </Th>
                      ))}
                    </Tr>

                    {/* SEARCH ROW */}
                    <Tr bg="#E0EAFF">
                      <Th></Th> {/* Empty for SR. NO */}
                      {Array(5)
                        .fill("")
                        .map((_, i) => (
                          <Th key={i} p={2} bg="#E0EAFF">
                            <InputGroup size="xs">
                              <InputLeftElement pointerEvents="none" h="100%">
                                <FiSearch color="#718EBF" fontSize="0.9rem" />
                              </InputLeftElement>

                              <Input
                                placeholder="Search"
                                bg="white"
                                borderRadius="4px"
                                pl="30px"
                                _focus={{ boxShadow: "none" }}
                              />
                            </InputGroup>
                          </Th>
                        ))}
                    </Tr>
                  </Thead>

                  <Tbody>
                    {payoutData?.length > 0 ? (
                      payoutData.map((row, index) => (
                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                          <Td>{row.srNo}</Td>
                          <Td>{row.payoutId}</Td>
                          <Td>{row.driver}</Td>
                          <Td fontWeight="600">{row.amount}</Td>
                          <Td>{row.method}</Td>
                          <Td>{row.schedule}</Td>
                          <Td>
                            <Badge
                              colorScheme={statusColorMap[row.status] || "gray"}
                              px={3}
                              py={1}
                              rounded="lg"
                            >
                              {row.status}
                            </Badge>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={7} textAlign="center" py={8}>
                          <Text color="#718EBF">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>

                {renderPagination(
                  payoutCurrentPage,
                  payoutTotalPages,
                  payoutTotalItems,
                  payoutItemsPerPage,
                  payoutData.length,
                  setPayoutCurrentPage,
                  setPayoutItemsPerPage,
                )}
              </Box>
            </TabPanel>

            {/* Failed Tab */}
            <TabPanel px={0}>
              {renderSearchAndFilterBar(
                failedSearchInput,
                setFailedSearchInput,
                handleFailedSearch,
                handleFailedKeyPress,
                [
                  { field: "driver", label: "Driver" },
                  { field: "date", label: "Date" },
                  { field: "reason", label: "Reason" },
                ],
                applyFailedSort,
                failedSortField,
                failedSortOrder,
                "Driver Failed Payouts",
              )}

              <Box p={7} bg="white" overflowX="auto" borderRadius="3xl">
                {deductionFetching && (
                  <Flex justify="center" py={4}>
                    <Text color="#718EBF">Loading...</Text>
                  </Flex>
                )}

                <Table size="sm" bg="white" fontSize="small">
                  <Thead>
                    {/* HEADER ROW */}
                    <Tr>
                      <Th color="#718EBF">SR. NO</Th>

                      {[
                        "DRIVER",
                        "DATE",
                        "AMOUNT",
                        "METHOD",
                        "TRANSACTION ID",
                        "REASON",
                      ].map((label) => (
                        <Th key={label} color="#718EBF">
                          <Flex align="center" gap={1}>
                            {label}
                            <TbArrowsSort color="#718EBF" fontSize="1rem" />
                          </Flex>
                        </Th>
                      ))}
                    </Tr>

                    {/* SEARCH ROW */}
                    <Tr bg="#E0EAFF">
                      <Th></Th> {/* Empty for SR. NO */}
                      {Array(6)
                        .fill("")
                        .map((_, i) => (
                          <Th key={i} p={2} bg="#E0EAFF">
                            <InputGroup size="xs">
                              <InputLeftElement pointerEvents="none" h="100%">
                                <FiSearch color="#718EBF" fontSize="0.9rem" />
                              </InputLeftElement>

                              <Input
                                placeholder="Search"
                                bg="white"
                                borderRadius="4px"
                                pl="30px"
                                _focus={{ boxShadow: "none" }}
                              />
                            </InputGroup>
                          </Th>
                        ))}
                    </Tr>
                  </Thead>

                  <Tbody>
                    {failedData?.length > 0 ? (
                      failedData.map((row, index) => (
                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                          <Td>{row.srNo}</Td>
                          <Td>{row.driver}</Td>
                          <Td>{row.date}</Td>

                          <Td fontWeight="600">{row.amount}</Td>
                          <Td>{row.method}</Td>
                          <Td>{row.transactionid}</Td>
                          <Td>{row.reason}</Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={5} textAlign="center" py={8}>
                          <Text color="#718EBF">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>

                {renderPagination(
                  failedCurrentPage,
                  failedTotalPages,
                  failedTotalItems,
                  failedItemsPerPage,
                  failedData.length,
                  setFailedCurrentPage,
                  setFailedItemsPerPage,
                )}
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Stack>
  );
};

export default DriverAccount;
